module.exports = __webpack_public_path__ + "static/media/seokyeong.803362f5.png";